import { Guid } from "guid-typescript";
import DistributionTypes from "../../types/enums/DistributionTypes";
import MessageAttachment from "../../types/system/MessageAttachment";
import MessageRecipient from "../../types/system/MessageRecipient";
import { MessageDetailMessage } from "./MessageDetail";
import RecipientTypes from "../enums/RecipientTypes";
import store, { IAppState } from "../../state/Store";

export default class Message {
    id: string;
    schoolId: number;
    clientSystemId: number;
    distribution: DistributionTypes[];
    customDistribution?: Record<DistributionTypes, number>;
    distributionStatus?: Record<DistributionTypes, boolean>;
    sender?: number;
    title: string;
    content: string;
    recipients: MessageRecipient[];
    attachments: MessageAttachment[];

    constructor(data?: Partial<Message>) {
        Object.assign(this, data);
    }

    static createMessage(title: string, content: string, userIds: number[]) {
        return new Message({
            id: Guid.create().toString(),
            title,
            content,
            recipients: userIds.map(id => ({
                recipientType: RecipientTypes.User,
                recipientId: id,
                customTarget: "",
                attachments: [],
            })),
            distribution: [DistributionTypes.TDS],
            attachments: [],
        });
    }

    static createEmail(
        subject: string,
        content: string,
        recipients: MessageRecipient[],
        attachments: MessageAttachment[] = [],
    ) {
        return new Message({
            id: Guid.create().toString(),
            title: subject,
            content,
            recipients: recipients,
            distribution: [DistributionTypes.Email],
            attachments: attachments,
        });
    }

    static createGeneric(
        title: string,
        content: string,
        recipients: MessageRecipient[] | number[],
        attachments?: MessageAttachment[],
        distribution?: DistributionTypes[],
    );
    static createGeneric(
        title: string,
        content: string,
        recipients: number[],
        attachments?: MessageAttachment[],
        distribution?: DistributionTypes[],
    );
    static createGeneric(
        title: string,
        content: string,
        recipients: MessageRecipient[] | number[],
        attachments: MessageAttachment[] = [],
        distribution: DistributionTypes[] = [DistributionTypes.Email],
    ) {
        const template = (
            store.getState().db
        ).messaging.templates.find(t => t.name === "GenericEmailTemplate");
        return new Message({
            id: Guid.create().toString(),
            title: title,
            content: template.body
                .replace("[EmailTitle]", title)
                .replace("[EmailContent]", content),
            recipients: recipients.map(item => {
                if (typeof item === "number") {
                    return {
                        recipientType: RecipientTypes.User,
                        recipientId: item,
                        customTarget: "",
                        attachments: [],
                    };
                } else {
                    return item;
                }
            }),
            distribution: distribution,
            attachments: attachments.concat(template.attachments),
        });
    }

    toMessageDetailMessage(): MessageDetailMessage {
        return {
            Id: this.id,
            UserID: this.sender,
            Users: this.recipients.map(r => r.recipientId),
            Message: this.content,
            Sent: new Date(),
            Read: true,

            Emojis: "",
            Emojiless: "",
        };
    }
}
